/**
 * Function wait CPB DOM elements to show up.
 * Work in modern browsers.
 * And execute callback.
 */
// var cpbLoaded = function () {
//   if (jQuery("#react-tabs-2").length > 0) {
//     console.log("CPB is loaded check");

//     customJS();
//   } else {
//     window.requestAnimationFrame(cpbLoaded);
//   }
// };

// cpbLoaded();

var checkExistFonts = setInterval(function () {
  if (jQuery(".cpb-custom-category-options-container").length != 0) {
    if (jQuery(".cpb-custom-combined-character__category-names").length != 0) {
      var character_text = "";
      var character_convert = "";
      let html = "";
      let html2 = "";
      var character_id = "";
      var character_text_id = "";
      var character_select_id = "";
      var character_select_id2 = "";
      var character_select_id3 = "";
      var character_input_id = "";
      var character_input_id2 = "";
      var character_input_id3 = "";
      var character_evp_id = "";
      var character_evp_id2 = "";
      var character_evp_id3 = "";
      var key_layer_character = "";
      var key_layer_font = "";

      var b = 0;

      if (
        jQuery(".cpb-custom-character").hasClass("cpb-custom-character1") ==
        true
      ) {
        character_text = jQuery(
          ".cpb-custom-character1 .cpb-custom-combined-character__category-names"
        ).html();
        character_convert = character_text.split("<div");

        character_id = jQuery(".cpb-custom-character1").attr("data-panel-id");
        character_text_id = "evp_character_sl_" + character_id;
        character_select_id2 = "evp_character" + character_id;
        character_input_id2 = "myInputSearchEVP" + character_id;
        character_evp_id2 = "character_evp" + character_id;

        if ($("#" + character_text_id).hasClass(character_text_id) != true) {
          html2 +=
            '<div id="' +
            character_text_id +
            '" class="evp_character_sl ' +
            character_text_id +
            '" style="width: 100%;display: flex;"><select name="' +
            character_select_id2 +
            '" id="' +
            character_select_id2 +
            '">';
          for (var i = 1; i < character_convert.length; i++) {
            html2 +=
              "<option value=" +
              i +
              "><div" +
              character_convert[i] +
              "</option>";
          }
          html2 += "</select>";
          html2 +=
            '<input type="text" style="margin-left: 20px;" id="' +
            character_input_id2 +
            '" placeholder="Search for names.." title="Type in a name"></div>';
          html2 +=
            '<div class="no_character_evp" style="display: flex;margin: 20px 0px;"><input type="checkbox" style="width: 40px;height: 15px;" id="' +
            character_evp_id2 +
            '" name="' +
            character_evp_id2 +
            '" value="no_character"><label for="' +
            character_evp_id2 +
            '">No Character</label></div>';
          jQuery(".cpb-custom-combined-character-category-names__item").css(
            "display",
            "none"
          );
        }

        //       jQuery('.cpb-custom-combined-character__category-names').empty();

        jQuery(".cpb-custom-character1")
          .find(
            ".cpb-custom-combined-character__category-names.cpb-custom-combined-character-category-names"
          )
          .append(html2);
        jQuery(".cpb-custom-character1")
          .find(
            ".cpb-custom-combined-character__category-names.cpb-custom-combined-character-category-names"
          )
          .css("display", "inline");
        // jQuery(".cpb-custom-character1 .cpb-custom-combined-character__category-names.cpb-custom-combined-character-category-names").append(html2);
        // jQuery(".cpb-custom-character1 .cpb-custom-combined-character__category-names.cpb-custom-combined-character-category-names").css(
        //   "display",
        //   "inline"
        // );

        key_layer_character = ".cpb-custom-character1";

        jQuery("#" + character_evp_id2).on("change", function () {
          if (
            jQuery("#" + character_evp_id2 + ":checkbox:checked").length == 1
          ) {
            jQuery(
              key_layer_character + " div.cpb-custom-option:last-child"
            ).addClass("active");
            jQuery(
              key_layer_character + " div.cpb-custom-option:last-child"
            ).trigger("click");
          } else {
            //             jQuery("div.cpb-custom-option:last-child").removeClass("active");
            jQuery(
              key_layer_character + " div.cpb-custom-option:nth-child(1)"
            ).addClass("active");
            jQuery(
              key_layer_character + " div.cpb-custom-option:nth-child(1)"
            ).trigger("click");
          }
        });
        jQuery("#" + character_select_id2).on("change", function () {
          console.log("character_select_id1");
          var boxes_cha1 = $(
            key_layer_character + " .cpb-custom-option.swiper-slide"
          ).filter(function (index) {
            $(this).removeClass("active");
          });
          jQuery("#" + character_input_id2).val("");
          jQuery("#" + character_input_id2).keyup();
          for (var i = 1; i < character_convert.length; i++) {
            jQuery(
              key_layer_character +
                " div.cpb-custom-combined-character__category-names div:nth-child(" +
                i +
                ")"
            ).removeClass("active");
            if (this.value == i) {
              jQuery(
                key_layer_character +
                  " div.cpb-custom-combined-character__category-names div:nth-child(" +
                  this.value +
                  ")"
              ).trigger("click");
              jQuery(
                key_layer_character +
                  " div.cpb-custom-combined-character__category-names div:nth-child(" +
                  this.value +
                  ")"
              ).addClass("active");
            }
          }
          // swiper.updateSlides();
        });
        const swiper1 = new Swiper(".swiper", {
          slidesPerView: 6,
          slidesPerGroup: 6,
          mousewheel: {
            thresholdDelta: 2,
          },
          grid: {
            rows: 2,
          },
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          observer: true,
          observeParents: true,
        });

        var typingTimer;
        var doneTypingInterval = 2000;

        jQuery("#" + character_input_id2).keyup(function () {
          var InputSearchEVP = $(this).val();

          $(key_layer_character + " .cpb-custom-option").hide();
          $(key_layer_character + " .cpb-custom-option").removeClass(
            "swiper-slide"
          );
          //         var nameAltArr = [];
          var boxes = $(key_layer_character + " .cpb-custom-option").filter(
            function (index) {
              if (
                !InputSearchEVP ||
                $(this)
                  .find(".cpb-custom-option__img")
                  .attr("alt")
                  .toLowerCase()
                  .indexOf(InputSearchEVP.toLowerCase()) >= 0
              ) {
                $(this).show();
                $(this).addClass("swiper-slide");
              }
            }
          );

          // swiper1.updateSlides();
          clearTimeout(typingTimer);
          if (InputSearchEVP) {
            typingTimer = setTimeout(doneTyping, doneTypingInterval);
          }
        });

        function doneTyping() {
          jQuery("#" + character_input_id2).blur();
          jQuery("#" + character_input_id2).focus();
          // jQuery("#" + character_input_id2).trigger('click');
        }

        if (jQuery(key_layer_character + " .cpb-custom-option").length > 0) {
          var div, j, txtalt;
          div = jQuery(key_layer_character + " .cpb-custom-option");

          for (
            j = 0;
            j < jQuery(key_layer_character + " .cpb-custom-option").length;
            j++
          ) {
            txtalt = div[j].getElementsByTagName("img")[0].alt;

            if (txtalt == "No Character") {
              div[j].getElementsByTagName("img")[0].style.display = "none";
            }
          }
        }

        // jQuery("span.option.option-type-color:first-child").addClass("active");
        // jQuery(
        //   "span.option.option-type-color:first-child .cpb-option-type-color-bg"
        // ).addClass("cpb-active");
        // jQuery(
        //   "span.option.option-type-color:first-child .cpb-option-type-color-bg"
        // ).trigger("click");
      }

      if (
        jQuery(".cpb-custom-character").hasClass("cpb-custom-character2") ==
        true
      ) {
        character_text = "";
        character_convert = "";

        character_text = jQuery(
          ".cpb-custom-character2 .cpb-custom-combined-character__category-names"
        ).html();
        character_convert = character_text.split("<div");

        character_id = jQuery(".cpb-custom-character2").attr("data-panel-id");
        character_text_id = "evp_character_sl_" + character_id;
        character_select_id = "evp_character" + character_id;
        character_input_id = "myInputSearchEVP" + character_id;
        character_evp_id = "character_evp" + character_id;

        if ($("#" + character_text_id).hasClass(character_text_id) != true) {
          html +=
            '<div id="' +
            character_text_id +
            '" class="evp_character_sl ' +
            character_text_id +
            '" style="width: 100%;display: flex;"><select name="' +
            character_select_id +
            '" id="' +
            character_select_id +
            '">';
          for (var i = 1; i < character_convert.length; i++) {
            html +=
              "<option value=" +
              i +
              "><div" +
              character_convert[i] +
              "</option>";
          }
          html += "</select>";
          html +=
            '<input type="text" style="margin-left: 20px;" id="' +
            character_input_id +
            '" placeholder="Search for names.." title="Type in a name"></div>';
          html +=
            '<div class="no_character_evp" style="display: flex;margin: 20px 0px;"><input type="checkbox" style="width: 40px;height: 15px;" id="' +
            character_evp_id +
            '" name="' +
            character_evp_id +
            '" value="no_character"><label for="' +
            character_evp_id +
            '">No Character</label></div>';
          jQuery(".cpb-custom-combined-character-category-names__item").css(
            "display",
            "none"
          );
        }

        //       jQuery('.cpb-custom-combined-character__category-names').empty();
        jQuery(
          ".cpb-custom-character2 .cpb-custom-combined-character__category-names.cpb-custom-combined-character-category-names"
        ).append(html);
        jQuery(
          ".cpb-custom-character2 .cpb-custom-combined-character__category-names.cpb-custom-combined-character-category-names"
        ).css("display", "inline");

        var key_layer_character2 = ".cpb-custom-character2";

        jQuery("#" + character_evp_id).on("change", function () {
          if (
            jQuery("#" + character_evp_id + ":checkbox:checked").length == 1
          ) {
            jQuery(
              key_layer_character2 + " div.cpb-custom-option:last-child"
            ).addClass("active");
            jQuery(
              key_layer_character2 + " div.cpb-custom-option:last-child"
            ).trigger("click");
          } else {
            //             jQuery("div.cpb-custom-option:last-child").removeClass("active");
            jQuery(
              key_layer_character2 + " div.cpb-custom-option:nth-child(1)"
            ).addClass("active");
            jQuery(
              key_layer_character2 + " div.cpb-custom-option:nth-child(1)"
            ).trigger("click");
          }
        });

        jQuery("#" + character_select_id).on("change", function () {
          var boxes_cha2 = $(
            ".cpb-custom-character2 .cpb-custom-option.swiper-slide"
          ).filter(function (index) {
            $(this).removeClass("active");
          });
          jQuery("#" + character_input_id).val("");
          jQuery("#" + character_input_id).keyup();
          for (var i = 1; i < character_convert.length; i++) {
            jQuery(
              key_layer_character2 +
                " div.cpb-custom-combined-character__category-names div:nth-child(" +
                i +
                ")"
            ).removeClass("active");
            if (this.value == i) {
              jQuery(
                key_layer_character2 +
                  " div.cpb-custom-combined-character__category-names div:nth-child(" +
                  this.value +
                  ")"
              ).trigger("click");
              jQuery(
                key_layer_character2 +
                  " div.cpb-custom-combined-character__category-names div:nth-child(" +
                  this.value +
                  ")"
              ).addClass("active");
            }
          }
        });

        if (jQuery(key_layer_character2 + " .cpb-custom-option").length > 0) {
          var div, j, txtalt;
          div = jQuery(key_layer_character2 + " .cpb-custom-option");

          for (
            j = 0;
            j < jQuery(key_layer_character2 + " .cpb-custom-option").length;
            j++
          ) {
            txtalt = div[j].getElementsByTagName("img")[0].alt;

            if (txtalt == "No Character") {
              div[j].getElementsByTagName("img")[0].style.display = "none";
            }
          }
        }

        const swiper2 = new Swiper(".swiper", {
          slidesPerView: 6,
          slidesPerGroup: 6,
          mousewheel: {
            thresholdDelta: 2,
          },
          grid: {
            rows: 2,
          },
          spaceBetween: 10,
          // navigation: {
          //   nextEl: ".swiper-button-next",
          //   prevEl: ".swiper-button-prev",
          // },
          observer: true,
          observeParents: true,
        });

        var typingTimer2;
        var doneTypingInterval2 = 2000;

        jQuery("#" + character_input_id).keyup(function () {
          var InputSearchEVP_cha2 = $(this).val();

          $(key_layer_character2 + " .cpb-custom-option").hide();
          $(key_layer_character2 + " .cpb-custom-option").removeClass(
            "swiper-slide"
          );

          var boxes = $(key_layer_character2 + " .cpb-custom-option").filter(
            function (index) {
              if (
                !InputSearchEVP_cha2 ||
                $(this)
                  .find(".cpb-custom-option__img")
                  .attr("alt")
                  .toLowerCase()
                  .indexOf(InputSearchEVP_cha2.toLowerCase()) >= 0
              ) {
                $(this).show();
                $(this).addClass("swiper-slide");
                //             }
              }
            }
          );

          clearTimeout(typingTimer2);
          if (InputSearchEVP_cha2) {
            typingTimer2 = setTimeout(doneTyping, doneTypingInterval2);
          }

          // swiper2.updateSlides();
        });

        function doneTyping() {
          jQuery("#" + character_input_id).blur();
          jQuery("#" + character_input_id).focus();
          // jQuery("#" + character_input_id).trigger('click');
        }
      }

      if (
        jQuery(".cpb-custom-character").hasClass("cpb-custom-character3") ==
        true
      ) {
        character_text = "";
        character_convert = "";

        character_text = jQuery(
          ".cpb-custom-character3 .cpb-custom-combined-character__category-names"
        ).html();
        character_convert = character_text.split("<div");

        character_id = jQuery(".cpb-custom-character3").attr("data-panel-id");
        character_text_id = "evp_character_sl_" + character_id;
        character_select_id3 = "evp_character" + character_id;
        character_input_id3 = "myInputSearchEVP" + character_id;
        character_evp_id3 = "character_evp" + character_id;

        var html3 = "";
        if ($("#" + character_text_id).hasClass(character_text_id) != true) {
          html3 +=
            '<div id="' +
            character_text_id +
            '" class="evp_character_sl ' +
            character_text_id +
            '" style="width: 100%;display: flex;"><select name="' +
            character_select_id3 +
            '" id="' +
            character_select_id3 +
            '">';
          for (var i = 1; i < character_convert.length; i++) {
            html3 +=
              "<option value=" +
              i +
              "><div" +
              character_convert[i] +
              "</option>";
          }
          html3 += "</select>";
          html3 +=
            '<input type="text" style="margin-left: 20px;" id="' +
            character_input_id3 +
            '" placeholder="Search for names.." title="Type in a name"></div>';
          html3 +=
            '<div class="no_character_evp" style="display: flex;margin: 20px 0px;"><input type="checkbox" style="width: 40px;height: 15px;" id="' +
            character_evp_id3 +
            '" name="' +
            character_evp_id3 +
            '" value="no_character"><label for="' +
            character_evp_id3 +
            '">No Character</label></div>';
          jQuery(".cpb-custom-combined-character-category-names__item").css(
            "display",
            "none"
          );
        }

        jQuery(
          ".cpb-custom-character3 .cpb-custom-combined-character__category-names.cpb-custom-combined-character-category-names"
        ).append(html3);
        jQuery(
          ".cpb-custom-character3 .cpb-custom-combined-character__category-names.cpb-custom-combined-character-category-names"
        ).css("display", "inline");

        var key_layer_character3 = ".cpb-custom-character3";

        jQuery("#" + character_evp_id3).on("change", function () {
          if (
            jQuery("#" + character_evp_id3 + ":checkbox:checked").length == 1
          ) {
            jQuery(
              key_layer_character3 + " div.cpb-custom-option:last-child"
            ).addClass("active");
            jQuery(
              key_layer_character3 + " div.cpb-custom-option:last-child"
            ).trigger("click");
          } else {
            //             jQuery("div.cpb-custom-option:last-child").removeClass("active");
            jQuery(
              key_layer_character3 + " div.cpb-custom-option:nth-child(1)"
            ).addClass("active");
            jQuery(
              key_layer_character3 + " div.cpb-custom-option:nth-child(1)"
            ).trigger("click");
          }
        });

        jQuery("#" + character_select_id3).on("change", function () {
          var boxes_cha3 = $(
            ".cpb-custom-character2 .cpb-custom-option.swiper-slide"
          ).filter(function (index) {
            $(this).removeClass("active");
          });
          jQuery("#" + character_input_id3).val("");
          jQuery("#" + character_input_id3).keyup();
          for (var i = 1; i < character_convert.length; i++) {
            jQuery(
              key_layer_character3 +
                " div.cpb-custom-combined-character__category-names div:nth-child(" +
                i +
                ")"
            ).removeClass("active");
            if (this.value == i) {
              jQuery(
                key_layer_character3 +
                  " div.cpb-custom-combined-character__category-names div:nth-child(" +
                  this.value +
                  ")"
              ).trigger("click");
              jQuery(
                key_layer_character3 +
                  " div.cpb-custom-combined-character__category-names div:nth-child(" +
                  this.value +
                  ")"
              ).addClass("active");
            }
          }
        });

        if (jQuery(key_layer_character3 + " .cpb-custom-option").length > 0) {
          var div, j, txtalt;
          div = jQuery(key_layer_character3 + " .cpb-custom-option");

          for (
            j = 0;
            j < jQuery(key_layer_character3 + " .cpb-custom-option").length;
            j++
          ) {
            txtalt = div[j].getElementsByTagName("img")[0].alt;

            if (txtalt == "No Character") {
              div[j].getElementsByTagName("img")[0].style.display = "none";
            }
          }
        }

        const swiper3 = new Swiper(".swiper", {
          slidesPerView: 6,
          slidesPerGroup: 6,
          mousewheel: {
            thresholdDelta: 2,
          },
          grid: {
            rows: 2,
          },
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          observer: true,
          observeParents: true,
        });

        var typingTimer3;
        var doneTypingInterval3 = 1500;

        jQuery("#" + character_input_id3).keyup(function () {
          var InputSearchEVP_cha3 = $(this).val();

          $(key_layer_character3 + " .cpb-custom-option").hide();
          $(key_layer_character3 + " .cpb-custom-option").removeClass(
            "swiper-slide"
          );
          //         var nameAltArr = [];
          var boxes = $(key_layer_character3 + " .cpb-custom-option").filter(
            function (index) {
              if (
                !InputSearchEVP_cha3 ||
                $(this)
                  .find(".cpb-custom-option__img")
                  .attr("alt")
                  .toLowerCase()
                  .indexOf(InputSearchEVP_cha3.toLowerCase()) >= 0
              ) {
                $(this).show();
                $(this).addClass("swiper-slide");
              }
            }
          );

          // swiper3.updateSlides();
          clearTimeout(typingTimer3);
          if (InputSearchEVP_cha3) {
            typingTimer3 = setTimeout(doneTyping, doneTypingInterval3);
          }
        });

        function doneTyping() {
          jQuery("#" + character_input_id3).blur();
          jQuery("#" + character_input_id3).focus();
          // jQuery("#" + character_input_id3).trigger('click');
        }
      }

      if (
        jQuery(".cpb-custom-character").hasClass("cpb-custom-character1") !=
          true &&
        jQuery(".cpb-custom-character").hasClass("cpb-custom-character2") !=
          true
      ) {
        character_text = "";
        character_convert = "";

        character_text = jQuery(
          ".cpb-custom-combined-character__category-names"
        ).html();
        character_convert = character_text.split("<div");

        character_id = jQuery(".cpb-custom-character").attr("data-panel-id");
        character_text_id = "evp_character_sl_" + character_id;
        character_select_id = "evp_character" + character_id;
        character_input_id = "myInputSearchEVP" + character_id;
        character_evp_id = "character_evp" + character_id;

        if ($("#" + character_text_id).hasClass(character_text_id) != true) {
          html +=
            '<div id="' +
            character_text_id +
            '" class="evp_character_sl ' +
            character_text_id +
            '" style="width: 100%;display: flex;"><select name="' +
            character_select_id +
            '" id="' +
            character_select_id +
            '">';
          for (var i = 1; i < character_convert.length; i++) {
            html +=
              "<option value=" +
              i +
              "><div" +
              character_convert[i] +
              "</option>";
          }
          html += "</select>";
          html +=
            '<input type="text" style="margin-left: 20px;" id="' +
            character_input_id +
            '" placeholder="Search for names.." title="Type in a name"></div>';
          html +=
            '<div class="no_character_evp" style="display: flex;margin: 20px 0px;"><input type="checkbox" style="width: 40px;height: 15px;" id="' +
            character_evp_id +
            '" name="' +
            character_evp_id +
            '" value="no_character"><label for="' +
            character_evp_id +
            '">No Character</label></div>';
          jQuery(".cpb-custom-combined-character-category-names__item").css(
            "display",
            "none"
          );
        }

        //       jQuery('.cpb-custom-combined-character__category-names').empty();
        jQuery(".cpb-custom-combined-character__category-names").append(html);
        jQuery(".cpb-custom-combined-character__category-names").css(
          "display",
          "inline"
        );

        jQuery("#" + character_evp_id).on("change", function () {
          if (
            jQuery("#" + character_evp_id + ":checkbox:checked").length == 1
          ) {
            jQuery("div.cpb-custom-option:last-child").addClass("active");
            jQuery("div.cpb-custom-option:last-child").trigger("click");
          } else {
            //             jQuery("div.cpb-custom-option:last-child").removeClass("active");
            jQuery("div.cpb-custom-option:nth-child(1)").addClass("active");
            jQuery("div.cpb-custom-option:nth-child(1)").trigger("click");
          }
        });

        jQuery("#" + character_select_id).on("change", function () {
          var boxes_default = $(".cpb-custom-option.swiper-slide").filter(
            function (index) {
              $(this).removeClass("active");
            }
          );
          jQuery("#" + character_input_id).val("");
          jQuery("#" + character_input_id).keyup();
          for (var i = 1; i < character_convert.length; i++) {
            jQuery(
              "div.cpb-custom-combined-character__category-names div:nth-child(" +
                i +
                ")"
            ).removeClass("active");
            if (this.value == i) {
              jQuery(
                "div.cpb-custom-combined-character__category-names div:nth-child(" +
                  this.value +
                  ")"
              ).trigger("click");
              jQuery(
                "div.cpb-custom-combined-character__category-names div:nth-child(" +
                  this.value +
                  ")"
              ).addClass("active");
            }
          }
        });

        if (jQuery(".cpb-custom-option").length > 0) {
          var div, j, txtalt;
          div = jQuery(".cpb-custom-option");

          for (j = 0; j < jQuery(".cpb-custom-option").length; j++) {
            txtalt = div[j].getElementsByTagName("img")[0].alt;

            if (txtalt == "No Character") {
              div[j].getElementsByTagName("img")[0].style.display = "none";
            }
          }
        }

        const swiper_default = new Swiper(".swiper", {
          slidesPerView: 6,
          slidesPerGroup: 6,
          mousewheel: {
            thresholdDelta: 2,
          },
          grid: {
            rows: 2,
          },
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          observer: true,
          observeParents: true,
        });

        jQuery("#" + character_input_id).keyup(function () {
          var InputSearchEVP = $(this).val();

          $(".cpb-custom-option").hide();
          $(".cpb-custom-option").removeClass("swiper-slide");
          //         var nameAltArr = [];
          var boxes = $(".cpb-custom-option").filter(function (index) {
            if (
              !InputSearchEVP ||
              $(this)
                .find(".cpb-custom-option__img")
                .attr("alt")
                .toLowerCase()
                .indexOf(InputSearchEVP.toLowerCase()) >= 0
            ) {
              //             var nameAlt = $(this).find('.cpb-custom-option__img').attr('alt').toLowerCase();

              //             if ( $.inArray(nameAlt, nameAltArr) == -1 ) {
              //               nameAltArr.push(nameAlt);
              $(this).show();
              $(this).addClass("swiper-slide");
              //             }
            }
          });

          swiper_default.updateSlides();
        });
      }
    }

    if (jQuery(".cpb-custom-font").hasClass("cpb-custom-font-slide1") == true) {
      //slider font layer1
      var font_html1 =
        '<div class="swiper-font1"><div class="swiper-wrapper swiper-wrapper-font-custom1">';
      //       var font_html1 += '<div class="cpb-custom-category-options-container cpb-custom-category-font">';

      var font_boxes1 = $(
        ".cpb-custom-font-slide1 .cpb-custom-category-options-container button.cpb-custom-option-font"
      ).filter(function (index) {
        //
        var text_font1 = $(this).text();
        var text_font_convert1 = text_font1.toLowerCase().replaceAll(" ", "_");
        text_font_convert1 = text_font_convert1
          .toLowerCase()
          .replaceAll("-", "_");
        $(this).addClass(text_font_convert1);

        font_html1 +=
          '<div class="cpb-custom-font-slide swiper-slide" data-font="' +
          text_font1 +
          '">';
        font_html1 +=
          '<span class="cpb-custom-option-font" font-text-convert="' +
          text_font_convert1 +
          '" font-convert="' +
          text_font_convert1 +
          '" data-font="' +
          text_font1 +
          '" style="font-family: ' +
          text_font1 +
          '">' +
          text_font1 +
          "</span>";
        font_html1 += "</div>";
      });

      font_html1 += "</div>";
      font_html1 +=
        '</div><div class="swiper-button-prev-font"></div><div class="swiper-button-next-font"></div>';

      //       $(".cpb-custom-category-options-container").empty();
      $(
        ".cpb-custom-font-slide1 .cpb-custom-category-options-container"
      ).append(font_html1);

      const swiper_font1 = new Swiper(".swiper-font1", {
        slidesPerView: 3,
        grid: {
          rows: 2,
        },
        a11y: false,
        thumbs: {
          autoScrollOffset: 0,
        },
        mousewheel: {
          thresholdDelta: 1,
        },
        slidesPerGroup: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-font",
          prevEl: ".swiper-button-prev-font",
        },
        observer: true,
        observeParents: true,
      });

      swiper_font1.updateSlides();
      $(
        ".cpb-custom-font-slide1 .swiper-font1 .swiper-slide .cpb-custom-option-font"
      ).on("click", function (e) {
        e.preventDefault();
        var font_data_span = $(this).attr("font-text-convert");
        var font_data = $(this).attr("font-convert");
        var font_data_text = $(this).attr("data-font");

        $(
          ".cpb-custom-font-slide1 .swiper-font1 .swiper-wrapper .cpb-custom-font-slide"
        ).removeClass("font-active");
        $(this).closest(".cpb-custom-font-slide").addClass("font-active");

        var boxes_font1 = $(
          ".cpb-custom-font-slide1 .cpb-custom-category-options-container button.cpb-custom-option-font"
        ).filter(function (index) {
          var text_font = $(this).text();

          if (font_data_text == text_font) {
            $(".cpb-custom-font-slide1 ." + font_data).addClass("active");
            $(".cpb-custom-font-slide1 ." + font_data).trigger("click");

            $(".cpb-custom-font-slide1 .option-type-fontFamily").addClass(
              "active"
            );
            $(".cpb-option-type-select").removeClass("css-2b097c-container");
            $(".cpb-option-type-select").addClass("cpb-has-value");
            $(".cpb-option-type-select").addClass("css-2b097c-container");
            $(".css-1uccc91-singleValue").text(font_data_text);
          } else {
            $(".cpb-custom-font-slide1 ." + font_data).removeClass("active");
          }
        });
      });
    }

    if (jQuery(".cpb-custom-font").hasClass("cpb-custom-font-slide2") == true) {
      var font_html2 =
        '<div class="swiper-font2"><div class="swiper-wrapper swiper-wrapper-font-custom2">';
      //       var font_html1 += '<div class="cpb-custom-category-options-container cpb-custom-category-font">';

      var font_boxes2 = $(
        ".cpb-custom-font-slide2 .cpb-custom-category-options-container button.cpb-custom-option-font"
      ).filter(function (index) {
        //
        var text_font2 = $(this).text();
        var text_font_convert2 = text_font2.toLowerCase().replaceAll(" ", "_");
        text_font_convert2 = text_font_convert2
          .toLowerCase()
          .replaceAll("-", "_");
        $(this).addClass(text_font_convert2);

        font_html2 +=
          '<div class="cpb-custom-font-slide swiper-slide" data-font="' +
          text_font2 +
          '">';
        font_html2 +=
          '<span class="cpb-custom-option-font" font-text-convert="' +
          text_font_convert2 +
          '" font-convert="' +
          text_font_convert2 +
          '" data-font="' +
          text_font2 +
          '" style="font-family: ' +
          text_font2 +
          '">' +
          text_font2 +
          "</span>";
        font_html2 += "</div>";
      });

      font_html2 += "</div>";
      font_html2 +=
        '</div><div class="swiper-button-prev-font"></div><div class="swiper-button-next-font"></div>';

      //       $(".cpb-custom-category-options-container").empty();
      $(
        ".cpb-custom-font-slide2 .cpb-custom-category-options-container"
      ).append(font_html2);

      const swiper_font2 = new Swiper(".swiper-font2", {
        slidesPerView: 3,
        grid: {
          rows: 2,
        },
        a11y: false,
        thumbs: {
          autoScrollOffset: 0,
        },
        mousewheel: {
          thresholdDelta: 1,
        },
        slidesPerGroup: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-font",
          prevEl: ".swiper-button-prev-font",
        },
        observer: true,
        observeParents: true,
      });

      swiper_font2.updateSlides();
      $(
        ".cpb-custom-font-slide2 .swiper-font2 .swiper-slide .cpb-custom-option-font"
      ).on("click", function (e) {
        e.preventDefault();
        var font_data_span = $(this).attr("font-text-convert");
        var font_data = $(this).attr("font-convert");
        var font_data_text = $(this).attr("data-font");

        $(
          ".cpb-custom-font-slide2 .swiper-font2 .swiper-wrapper .cpb-custom-font-slide"
        ).removeClass("font-active");
        $(this).closest(".cpb-custom-font-slide").addClass("font-active");

        var boxes_font2 = $(
          ".cpb-custom-font-slide2 .cpb-custom-category-options-container button.cpb-custom-option-font"
        ).filter(function (index) {
          var text_font = $(this).text();

          if (font_data_text == text_font) {
            $(".cpb-custom-font-slide2 ." + font_data).addClass("active");
            $(".cpb-custom-font-slide2 ." + font_data).trigger("click");

            $(".cpb-custom-font-slide2 .option-type-fontFamily").addClass(
              "active"
            );
            $(".cpb-custom-font-slide2 .cpb-option-type-select").removeClass(
              "css-2b097c-container"
            );
            $(".cpb-custom-font-slide2 .cpb-option-type-select").addClass(
              "cpb-has-value"
            );
            $(".cpb-custom-font-slide2 .cpb-option-type-select").addClass(
              "css-2b097c-container"
            );
            $(".cpb-custom-font-slide2 .css-1uccc91-singleValue").text(
              font_data_text
            );
          } else {
            $(".cpb-custom-font-slide2 ." + font_data).removeClass("active");
          }
        });
      });
    }

    if (jQuery(".cpb-custom-font").hasClass("cpb-custom-font-slide3") == true) {
      var font_html3 =
        '<div class="swiper-font3"><div class="swiper-wrapper swiper-wrapper-font-custom3">';
      //       var font_html1 += '<div class="cpb-custom-category-options-container cpb-custom-category-font">';

      var font_boxes3 = $(
        ".cpb-custom-font-slide3 .cpb-custom-category-options-container button.cpb-custom-option-font"
      ).filter(function (index) {
        //
        var text_font3 = $(this).text();
        var text_font_convert3 = text_font3.toLowerCase().replaceAll(" ", "_");
        text_font_convert3 = text_font_convert3
          .toLowerCase()
          .replaceAll("-", "_");
        $(this).addClass(text_font_convert3);

        font_html3 +=
          '<div class="cpb-custom-font-slide swiper-slide" data-font="' +
          text_font3 +
          '">';
        font_html3 +=
          '<span class="cpb-custom-option-font" font-text-convert="' +
          text_font_convert3 +
          '" font-convert="' +
          text_font_convert3 +
          '" data-font="' +
          text_font3 +
          '" style="font-family: ' +
          text_font3 +
          '">' +
          text_font3 +
          "</span>";
        font_html3 += "</div>";
      });

      font_html3 += "</div>";
      font_html3 +=
        '</div><div class="swiper-button-prev-font"></div><div class="swiper-button-next-font"></div>';

      //       $(".cpb-custom-category-options-container").empty();
      $(
        ".cpb-custom-font-slide3 .cpb-custom-category-options-container"
      ).append(font_html3);

      const swiper_font2 = new Swiper(".swiper-font3", {
        slidesPerView: 3,
        grid: {
          rows: 2,
        },
        a11y: false,
        thumbs: {
          autoScrollOffset: 0,
        },
        mousewheel: {
          thresholdDelta: 1,
        },
        slidesPerGroup: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-font",
          prevEl: ".swiper-button-prev-font",
        },
        observer: true,
        observeParents: true,
      });

      swiper_font2.updateSlides();
      $(
        ".cpb-custom-font-slide3 .swiper-font3 .swiper-slide .cpb-custom-option-font"
      ).on("click", function (e) {
        e.preventDefault();
        var font_data_span = $(this).attr("font-text-convert");
        var font_data = $(this).attr("font-convert");
        var font_data_text = $(this).attr("data-font");

        $(
          ".cpb-custom-font-slide3 .swiper-font3 .swiper-wrapper .cpb-custom-font-slide"
        ).removeClass("font-active");
        $(this).closest(".cpb-custom-font-slide").addClass("font-active");

        var boxes_font2 = $(
          ".cpb-custom-font-slide3 .cpb-custom-category-options-container button.cpb-custom-option-font"
        ).filter(function (index) {
          var text_font = $(this).text();

          if (font_data_text == text_font) {
            $(".cpb-custom-font-slide3 ." + font_data).addClass("active");
            $(".cpb-custom-font-slide3 ." + font_data).trigger("click");

            $(".cpb-custom-font-slide3 .option-type-fontFamily").addClass(
              "active"
            );
            $(".cpb-custom-font-slide3 .cpb-option-type-select").removeClass(
              "css-2b097c-container"
            );
            $(".cpb-custom-font-slide3 .cpb-option-type-select").addClass(
              "cpb-has-value"
            );
            $(".cpb-custom-font-slide3 .cpb-option-type-select").addClass(
              "css-2b097c-container"
            );
            $(".cpb-custom-font-slide3 .css-1uccc91-singleValue").text(
              font_data_text
            );
          } else {
            $(".cpb-custom-font-slide3 ." + font_data).removeClass("active");
          }
        });
      });
    }

    if (jQuery(".cpb-custom-font").hasClass("iz-custom-font-slide") == true) {
      var font_html =
        '<div class="swiper-font"><div class="swiper-wrapper swiper-wrapper-font-custom">';
      //       var font_html += '<div class="cpb-custom-category-options-container cpb-custom-category-font">';

      var boxes = $(
        ".cpb-custom-category-options-container button.cpb-custom-option-font"
      ).filter(function (index) {
        //
        var text_font = $(this).text();
        var text_font_convert = text_font.toLowerCase().replaceAll(" ", "_");
        text_font_convert = text_font_convert
          .toLowerCase()
          .replaceAll("-", "_");
        $(this).addClass(text_font_convert);

        font_html +=
          '<div class="cpb-custom-font-slide swiper-slide" data-font="' +
          text_font +
          '">';
        font_html +=
          '<span class="cpb-custom-option-font" font-text-convert="' +
          text_font_convert +
          '" font-convert="' +
          text_font_convert +
          '" data-font="' +
          text_font +
          '" style="font-family: ' +
          text_font +
          '">' +
          text_font +
          "</span>";
        font_html += "</div>";
      });

      font_html += "</div>";
      font_html +=
        '</div><div class="swiper-button-prev-font"></div><div class="swiper-button-next-font"></div>';

      //       $(".cpb-custom-category-options-container").empty();
      $(".cpb-custom-category-options-container").append(font_html);

      const swiper_font = new Swiper(".swiper-font", {
        slidesPerView: 3,
        grid: {
          rows: 2,
        },
        a11y: false,
        thumbs: {
          autoScrollOffset: 0,
        },
        mousewheel: {
          thresholdDelta: 1,
        },
        slidesPerGroup: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-font",
          prevEl: ".swiper-button-prev-font",
        },
        observer: true,
        observeParents: true,
      });

      swiper_font.updateSlides();

      $(".swiper-font .swiper-slide .cpb-custom-option-font").on(
        "click",
        function (e) {
          e.preventDefault();
          var font_data_span = $(this).attr("font-text-convert");
          var font_data = $(this).attr("font-convert");
          var font_data_text = $(this).attr("data-font");

          $(".swiper-font .swiper-wrapper .cpb-custom-font-slide").removeClass(
            "font-active"
          );
          $(this).closest(".cpb-custom-font-slide").addClass("font-active");

          var boxes = $(
            ".cpb-custom-category-options-container button.cpb-custom-option-font"
          ).filter(function (index) {
            var text_font = $(this).text();
            if (font_data_text == text_font) {
              $("." + font_data).addClass("active");
              $("." + font_data).trigger("click");

              $(".option-type-fontFamily").addClass("active");
              $(".cpb-option-type-select").removeClass("css-2b097c-container");
              $(".cpb-option-type-select").addClass("cpb-has-value");
              $(".cpb-option-type-select").addClass("css-2b097c-container");
              $(".css-1uccc91-singleValue").text(font_data_text);
            } else {
              $("." + font_data).removeClass("active");
            }
          });
        }
      );
    }

    // Font select default
    if (jQuery(".cpb-panel-wrapper").hasClass("cpb-custom-font") == true) {
      jQuery('div.cpb-custom-font-slide[data-font="Comfy-Couch"]').addClass(
        "font-active"
      );
      jQuery("button.cpb-custom-option-font[data-font = Comfy-Couch]").trigger(
        "click"
      );
    }
    var runTimeCharacter = setInterval(function () {
      // Character select default
      if (
        jQuery(".cpb-panel-wrapper").hasClass("cpb-custom-character") == true
      ) {
        jQuery(
          ".cpb-custom-combined-character-slider-container__inner .cpb-custom-option.swiper-slide:nth-child(1)"
        ).trigger("click");
      }
      clearInterval(runTimeCharacter);
    }, 1000);
    // custom slider for color
    if (
      jQuery(".cpb-custom-color").hasClass("cpb-custom-color-slider1") == true
    ) {
      var class_color1 = "cpb-custom-color-slider1";
      var class_swiper_color1 = "swiper-color1";
      var color_html1 =
        '<div class="' +
        class_swiper_color1 +
        '"><div class="swiper-wrapper swiper-wrapper-color-custom1">';

      var color_boxes1 = $(
        ".cpb-custom-color." +
          class_color1 +
          " .cpb-category-options-container .option-type-color"
      ).filter(function (index) {
        var html_color1 = $(this).html();
        var text_color1 = $(this).text();
        var text_color_convert1 = text_color1
          .toLowerCase()
          .replaceAll(" ", "_");
        text_color_convert1 = text_color_convert1
          .toLowerCase()
          .replaceAll("-", "_");
        $(this).addClass(text_color_convert1);

        color_html1 += '<div class="cpb-custom-color-slide1 swiper-slide">';
        color_html1 +=
          '<span class="option option-type-color custom-color-slide1" data-color=' +
          text_color_convert1 +
          ">" +
          html_color1 +
          "</span>";
        color_html1 += "</div>";
      });

      color_html1 += "</div>";
      color_html1 +=
        '</div><div class="swiper-button-prev-color"></div><div class="swiper-button-next-color"></div>';

      //       $(".cpb-custom-category-options-container").empty();
      $("." + class_color1 + " .cpb-category-options-container.color").append(
        color_html1
      );

      const swiper_color1 = new Swiper("." + class_swiper_color1, {
        slidesPerView: 6,
        grid: {
          rows: 2,
        },
        a11y: false,
        thumbs: {
          autoScrollOffset: 0,
        },
        mousewheel: {
          thresholdDelta: 1,
        },
        slidesPerGroup: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-color",
          prevEl: ".swiper-button-prev-color",
        },
        observer: true,
        observeParents: true,
      });

      // swiper_color1.updateSlides();

      $(
        "." +
          class_color1 +
          " ." +
          class_swiper_color1 +
          " .swiper-slide .option-type-color"
      ).on("click", function (e) {
        e.preventDefault();

        $("." + class_color1 + " .cpb-option-type-color").removeClass(
          "cpb-active"
        );
        $(this).addClass("active");
        $(this).find(".cpb-option-type-color").addClass("cpb-active");
        $(this).closest(".cpb-option-type-color").addClass("cpb-active");
        var color_data_text1 = $(this).text();
        var color_data1 = $(this).attr("data-color");

        var boxes1 = $(
          "." +
            class_color1 +
            " .cpb-category-options-container .option-type-color"
        ).filter(function (index) {
          var text_color1 = $(this).text();

          var textColor_convert1 = text_color1
            .toLowerCase()
            .replaceAll(" ", "_");
          if ($(this).hasClass("custom-color-slide1") != true) {
            if ($(this).hasClass(textColor_convert1) != true) {
              $(this).addClass(textColor_convert1);
            }
          }

          if (color_data_text1 == text_color1) {
            $("." + class_color1 + " ." + color_data1).addClass("active");
            $("." + class_color1 + " ." + color_data1)
              .find(".cpb-option-type-color")
              .addClass("cpb-active");
            $("." + class_color1 + " ." + color_data1)
              .find(".cpb-option-type-color")
              .trigger("click");
          } else {
            // $('.' + color_data).removeClass("active");
            // $('.' + color_data).find('.cpb-option-type-color').removeClass("cpb-active");
          }
        });
      });
    }

    if (
      jQuery(".cpb-custom-color").hasClass("cpb-custom-color-slider2") == true
    ) {
      var class_color2 = "cpb-custom-color-slider2";
      var class_swiper_color2 = "swiper-color2";
      var color_html2 =
        '<div class="' +
        class_swiper_color2 +
        '"><div class="swiper-wrapper swiper-wrapper-color-custom2">';

      var color_boxes2 = $(
        ".cpb-custom-color." +
          class_color2 +
          " .cpb-category-options-container .option-type-color"
      ).filter(function (index) {
        var html_color2 = $(this).html();
        var text_color2 = $(this).text();
        var text_color_convert2 = text_color2
          .toLowerCase()
          .replaceAll(" ", "_");
        text_color_convert2 = text_color_convert2
          .toLowerCase()
          .replaceAll("-", "_");
        $(this).addClass(text_color_convert2);

        color_html2 += '<div class="cpb-custom-color-slide2 swiper-slide">';
        color_html2 +=
          '<span class="option option-type-color custom-color-slide2" data-color=' +
          text_color_convert2 +
          ">" +
          html_color2 +
          "</span>";
        color_html2 += "</div>";
      });

      color_html2 += "</div>";
      color_html2 +=
        '</div><div class="swiper-button-prev-color"></div><div class="swiper-button-next-color"></div>';

      //       $(".cpb-custom-category-options-container").empty();
      $("." + class_color2 + " .cpb-category-options-container.color").append(
        color_html2
      );

      const swiper_color2 = new Swiper("." + class_swiper_color2, {
        slidesPerView: 6,
        grid: {
          rows: 2,
        },
        a11y: false,
        thumbs: {
          autoScrollOffset: 0,
        },
        mousewheel: {
          thresholdDelta: 1,
        },
        slidesPerGroup: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-color",
          prevEl: ".swiper-button-prev-color",
        },
        observer: true,
        observeParents: true,
      });

      // swiper_color.updateSlides();

      $(
        "." +
          class_color2 +
          " ." +
          class_swiper_color2 +
          " .swiper-slide .option-type-color"
      ).on("click", function (e) {
        e.preventDefault();

        $("." + class_color2 + " .cpb-option-type-color").removeClass(
          "cpb-active"
        );
        $(this).addClass("active");
        $(this).find(".cpb-option-type-color").addClass("cpb-active");
        $(this).closest(".cpb-option-type-color").addClass("cpb-active");
        var color_data_text2 = $(this).text();
        var color_data2 = $(this).attr("data-color");

        var boxes2 = $(
          "." +
            class_color2 +
            " .cpb-category-options-container .option-type-color"
        ).filter(function (index) {
          var text_color2 = $(this).text();
          var textColor_convert2 = text_color2
            .toLowerCase()
            .replaceAll(" ", "_");
          if ($(this).hasClass("custom-color-slide2") != true) {
            if ($(this).hasClass(textColor_convert2) != true) {
              $(this).addClass(textColor_convert2);
            }
          }
          if (color_data_text2 == text_color2) {
            $("." + class_color2 + " ." + color_data2).addClass("active");
            $("." + class_color2 + " ." + color_data2)
              .find(".cpb-option-type-color")
              .addClass("cpb-active");
            $("." + class_color2 + " ." + color_data2)
              .find(".cpb-option-type-color")
              .trigger("click");
          } else {
            // $('.' + color_data).removeClass("active");
            // $('.' + color_data).find('.cpb-option-type-color').removeClass("cpb-active");
          }
        });
      });
    }

    if (
      jQuery(".cpb-custom-color").hasClass("cpb-custom-color-slider3") == true
    ) {
      var class_color3 = "cpb-custom-color-slider3";
      var class_swiper_color3 = "swiper-color3";
      var color_html3 =
        '<div class="' +
        class_swiper_color3 +
        '"><div class="swiper-wrapper swiper-wrapper-color-custom3">';

      var color_boxes3 = $(
        ".cpb-custom-color." +
          class_color3 +
          " .cpb-category-options-container .option-type-color"
      ).filter(function (index) {
        var html_color3 = $(this).html();
        var text_color3 = $(this).text();
        var text_color_convert3 = text_color3
          .toLowerCase()
          .replaceAll(" ", "_");
        text_color_convert3 = text_color_convert3
          .toLowerCase()
          .replaceAll("-", "_");
        $(this).addClass(text_color_convert3);

        color_html3 += '<div class="cpb-custom-color-slide3 swiper-slide">';
        color_html3 +=
          '<span class="option option-type-color custom-color-slide3" data-color=' +
          text_color_convert3 +
          ">" +
          html_color3 +
          "</span>";
        color_html3 += "</div>";
      });

      color_html3 += "</div>";
      color_html3 +=
        '</div><div class="swiper-button-prev-color"></div><div class="swiper-button-next-color"></div>';

      //       $(".cpb-custom-category-options-container").empty();
      $("." + class_color3 + " .cpb-category-options-container.color").append(
        color_html3
      );

      const swiper_color3 = new Swiper("." + class_swiper_color3, {
        slidesPerView: 6,
        grid: {
          rows: 2,
        },
        a11y: false,
        thumbs: {
          autoScrollOffset: 0,
        },
        mousewheel: {
          thresholdDelta: 1,
        },
        slidesPerGroup: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-color",
          prevEl: ".swiper-button-prev-color",
        },
        observer: true,
        observeParents: true,
      });

      // swiper_color.updateSlides();

      $(
        "." +
          class_color3 +
          " ." +
          class_swiper_color3 +
          " .swiper-slide .option-type-color"
      ).on("click", function (e) {
        e.preventDefault();

        $("." + class_color3 + " .cpb-option-type-color").removeClass(
          "cpb-active"
        );
        $(this).addClass("active");
        $(this).find(".cpb-option-type-color").addClass("cpb-active");
        $(this).closest(".cpb-option-type-color").addClass("cpb-active");
        var color_data_text3 = $(this).text();
        var color_data3 = $(this).attr("data-color");

        var boxes3 = $(
          "." +
            class_color3 +
            " .cpb-category-options-container .option-type-color"
        ).filter(function (index) {
          var text_color3 = $(this).text();
          var textColor_convert3 = text_color3
            .toLowerCase()
            .replaceAll(" ", "_");
          if ($(this).hasClass("custom-color-slide3") != true) {
            if ($(this).hasClass(textColor_convert3) != true) {
              $(this).addClass(textColor_convert3);
            }
          }
          if (color_data_text3 == text_color3) {
            $("." + class_color3 + " ." + color_data3).addClass("active");
            $("." + class_color3 + " ." + color_data3)
              .find(".cpb-option-type-color")
              .addClass("cpb-active");
            $("." + class_color3 + " ." + color_data3)
              .find(".cpb-option-type-color")
              .trigger("click");
          } else {
            // $('.' + color_data).removeClass("active");
            // $('.' + color_data).find('.cpb-option-type-color').removeClass("cpb-active");
          }
        });
      });
    }

    if (
      jQuery(".cpb-custom-color").hasClass("cpb-custom-color-slider") == true &&
      jQuery(".cpb-custom-color").hasClass("cpb-custom-color-slider1") !=
        true &&
      jQuery(".cpb-custom-color").hasClass("cpb-custom-color-slide2") != true
    ) {
      var color_html =
        '<div class="swiper-color"><div class="swiper-wrapper swiper-wrapper-color-custom">';
      // var font_html += '<div class="cpb-custom-category-options-container cpb-custom-category-font">';

      var color_boxes = $(
        ".cpb-custom-color.cpb-custom-color-slider .cpb-category-options-container .option-type-color"
      ).filter(function (index) {
        var html_color = $(this).html();
        var text_color = $(this).text();
        var text_color_convert = text_color.toLowerCase().replaceAll(" ", "_");
        text_color_convert = text_color_convert
          .toLowerCase()
          .replaceAll("-", "_");
        $(this).addClass(text_color_convert);

        color_html += '<div class="cpb-custom-color-slide swiper-slide">';
        color_html +=
          '<span class="option option-type-color custom-color-slide" data-color=' +
          text_color_convert +
          ">" +
          html_color +
          "</span>";
        color_html += "</div>";
      });

      color_html += "</div>";
      color_html +=
        '</div><div class="swiper-button-prev-color"></div><div class="swiper-button-next-color"></div>';

      //       $(".cpb-custom-category-options-container").empty();
      $(
        ".cpb-custom-color-slider .cpb-category-options-container.color"
      ).append(color_html);

      const swiper_color = new Swiper(".swiper-color", {
        slidesPerView: 6,
        grid: {
          rows: 2,
        },
        a11y: false,
        thumbs: {
          autoScrollOffset: 0,
        },
        mousewheel: {
          thresholdDelta: 1,
        },
        slidesPerGroup: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-color",
          prevEl: ".swiper-button-prev-color",
        },
        observer: true,
        observeParents: true,
      });

      // swiper_color.updateSlides();

      $(
        ".cpb-custom-color-slider .swiper-color .swiper-slide .option-type-color"
      ).on("click", function (e) {
        e.preventDefault();

        var textClass = $(this).attr("class");
        var textColor = $(this).find(".cpb-option-label").text();

        $(".cpb-custom-color-slide .cpb-option-type-color").removeClass(
          "cpb-active"
        );
        $(this).addClass("active");
        $(this).find(".cpb-option-type-color").addClass("cpb-active");
        $(this).closest(".cpb-option-type-color").addClass("cpb-active");
        var color_data_text = $(this).text();
        var color_data = $(this).attr("data-color");

        // add class for color white layer
        if (color_data_text == "White") {
          $(".cpb-preview-container").addClass("iz-custom-bg-layer");
        } else {
          $(".cpb-preview-container").removeClass("iz-custom-bg-layer");
        }

        var boxes = $(
          ".cpb-custom-color-slider .cpb-category-options-container .option-type-color"
        ).filter(function (index) {
          var text_color = $(this).text();

          var textColor_convert = text_color.toLowerCase().replaceAll(" ", "_");
          if ($(this).hasClass("custom-color-slide") != true) {
            if ($(this).hasClass(textColor_convert) != true) {
              $(this).addClass(textColor_convert);
            }
          }

          if (color_data_text == text_color) {
            // console.log("text_color: " + text_color);

            // $("." + color_data).addClass(text_color);
            $("." + color_data).addClass(text_color + " active");
            $("." + color_data)
              .find(".cpb-option-type-color")
              .addClass("cpb-active");
            $("." + color_data)
              .find(".cpb-option-type-color")
              .trigger("click");
          } else {
            // $(this).removeClass("active");
            // $(this).find(".cpb-option-type-color").removeClass("cpb-active");
            // var textColor_convert = text_color
            //   .toLowerCase()
            //   .replaceAll(" ", "_");
            // if ($(this).hasClass(textColor_convert) != true) {
            //   console.log("textColor_convert: ", textColor_convert);
            //   $(this).addClass(textColor_convert);
            // }
          }
        });
      });
    }

    if (
      jQuery(".cpb-custom-color").hasClass("cpb-custom-color-slider") != true &&
      jQuery(".cpb-custom-color").hasClass("cpb-custom-color-slider1") !=
        true &&
      jQuery(".cpb-custom-color").hasClass("cpb-custom-color-slide2") != true
    ) {
      $(
        ".cpb-custom-color .cpb-panel-categories-container .cpb-category-options-container.color .option-type-color"
      ).on("click", function (e) {
        e.preventDefault();

        var codeColor = $(this).find(".cpb-option-type-color-bg").attr("style");

        let colorResult = codeColor.includes("rgb(255, 255, 255)");

        //add class for color white layer
        if (colorResult == true) {
          $(".cpb-preview-container").addClass("iz-custom-bg-layer");
        } else {
          $(".cpb-preview-container").removeClass("iz-custom-bg-layer");
        }
      });
    }

    var info_tabs = jQuery(".cpb-custom-info-tabs-wrapper").html();
    var info_tabs_button_html = "";
    if (info_tabs) {
      jQuery("button.cpb-custom-toggle-description.cpb-custom-button").hide();

      jQuery(".cpb-custom-info-tabs-wrapper").hide();
      // info_tabs_button_html = '<span class="button-customize">Click to Customize</span>';
      info_tabs_button_html += '<div class="cpb-custom-info-tabs-wrapper">';
      info_tabs_button_html += info_tabs;
      info_tabs_button_html += "</div>";
    } else {
      // info_tabs_button_html = '<span class="button-customize">Click to Customize</span>';
    }

    jQuery(".cpb-panels-container").append(info_tabs_button_html);
    jQuery(".cpb-custom-info-tabs-titles").on("click", function (event) {
      if (jQuery(".button-customize").css("display") != "none") {
        if (jQuery(".cpb-custom-info-tabs-content").css("display") == "none") {
          // jQuery('.cpb-panels-container.col-list.cpb-current-tab-index-0.initialPanel').css('height', '100%');
        } else {
          // jQuery('.cpb-panels-container.col-list.cpb-current-tab-index-0.initialPanel').css('height', '440px');
        }
      }
      jQuery(".cpb-custom-info-tabs-content").toggle("show");
    });

    $(".cpb-panel-title").filter(function (index) {
      var text_font = $(this).text();

      if (text_font == "Description") {
        jQuery(this).addClass("iz-hide");
      }
    });

    jQuery("body").on("click", ".button-customize", function () {
      jQuery(".cpb-product-actions").css("margin-top", "30px");
      jQuery(".cpb-product-actions").css("margin-bottom", "40px");

      jQuery(".cpb-custom-toggle-description")
        .trigger("click")
        .slideUp(300)
        .fadeIn(400);
      jQuery(".button-customize").addClass("iz-hide");
      jQuery(".cpb-category-options-container.color").removeClass("iz-hide");
      jQuery(
        ".cpb-panel-wrapper .cpb-panel-categories-container .cpb-category-color"
      )
        .removeClass("iz-hide")
        .slideUp(300)
        .fadeIn(400);
      jQuery(".cpb-custom-character")
        .removeClass("iz-hide")
        .slideUp(300)
        .fadeIn(400);
      jQuery(".cpb-category-inputMulti")
        .removeClass("iz-hide")
        .slideUp(300)
        .fadeIn(400);
      jQuery(".swiper-wrapper-font-custom")
        .removeClass("iz-hide")
        .slideUp(300)
        .fadeIn(400);
      jQuery(".swiper-button-prev-font")
        .removeClass("iz-hide")
        .slideUp(300)
        .fadeIn(400);
      jQuery(".swiper-button-next-font")
        .removeClass("iz-hide")
        .slideUp(300)
        .fadeIn(400);
      jQuery(".cpb-add-to-cart-button")
        .removeClass("iz-hide")
        .slideUp(300)
        .fadeIn(400);
      jQuery(".cpb-add-to-cart-button")
        .removeClass("iz-hide")
        .slideUp(300)
        .fadeIn(400);
      $(".cpb-panel-title").filter(function (index) {
        var text_font = $(this).text();

        if (text_font == "Description") {
          jQuery(this).removeClass("iz-hide").slideUp(300).fadeIn(400);
        }
      });
    });

    clearInterval(checkExistFonts);
  }
}, 2000);

// check url
// var url = window.location.href;
// if (url.indexOf("products") != -1) {
//   if (url.indexOf("?cpbPreview=true") == -1) {
//     let searchParams = new URLSearchParams(window.location.search);
//     if (!searchParams.has("cpbPreview")) {
//       window.location.replace(url + "?cpbPreview=true");
//     }
//   }
// }
